import React, { useState, Suspense } from 'react';
import { NavLink } from "react-router-dom";
import LightBox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import lightboxStyle from "../styles/Lightbox.module.scss";
import {useTranslation, Trans,} from "react-i18next";

const IMAGES = [
	{
	  src: "./images/6Bagatellen_Webern.png",
	  isSelected: true,
	  caption: "bag",
	  title: "bag",
	  id: "bagatellen",
	  rez: "",
	  nav: ""
	},
	{
	  src: "./images/Gotteslob.jpg",
	  caption: "got",
	  title: "got",
	  id: "gotteslob",
	  rez: "got",
	  nav: "rezensionen#bumiller",
	},
	{
	  src: "./images/KritBer_UrtextPrimo.png",
	  caption: "pri",
	  title: "pri",
	  id: "wiener",
	  rez: "pri",
	  nav:"rezensionen#wiener"
	},
	{
		src: "images/006Pars-Pro-Toto-Spiel_Zimmerm-14.jpg",
		title: "zim",
		caption: "zim",
		id: "zimmermann",
		rez: "",
		nav: ""
	}
  ];

  function HeaderComponent()
{
	const {t} = useTranslation('translation');

	const [showLight, setShowLight] = useState(null);
  
	const showLightBox = (index) => {
	  setShowLight({
		startIndex: index
	  });
	};
  
	const hideLightBox = () => {
	  setShowLight(null);
	};
	  
	const presentCaption = (caption) => t(`examples.caption.${caption}`);
	const presentAlt = (title) => t(`examples.title.${title}`);
	const presentRezension = (rez) => {
		switch (rez) {
		  case 'got':
			return t('examples.rez.got');
	  
		  case 'pri':
			return t('examples.rez.pri');
	  
		  default:
			return "";
		}
	  };

    return <div className="beispiele" id="wrapper">
	<main>
		<h2>{t('examples.h2')}</h2>
		<h4>{t('examples.h4')}</h4>
<div>
{IMAGES.map((image, index) => (
  <div className={lightboxStyle.bsp_container} key={image.id}>
	 <img
	src={image.src}
	alt={t(presentAlt(image.title))}
	style={{ margin: 10 }}
	width="100%"
	height="auto"
	onClick={() => showLightBox(index)}
	id={image.id}
  />
  <p>{t(presentCaption(image.caption))}</p>
	<p className={lightboxStyle.redirect}><NavLink to={image.nav}>{t(presentRezension(image.rez))}</NavLink></p>
  </div>
))}	
{showLight ? (
  <LightBox
	images={IMAGES.map((img) => ({ url: img.src, [t(presentAlt(img.title))]: 
		[t(presentCaption(img.caption))] }))}
	startIndex={showLight.startIndex}
	onClose={hideLightBox}

  />
) : null}
</div>
</main>
<aside>
<h2>{t('examples.aside.h2')}</h2>
<ul>
	<Trans i18nKey="examples.aside.li" components={<li />}/>
</ul>
</aside>
</div>
}

const Beispiele = () => {
	
	return (
		<Suspense fallback="loading">
	<div className="App">
		<HeaderComponent/>
	</div>
</Suspense>
	);
  };
  
  export default Beispiele;